(function() {

  const megamenu = document.querySelectorAll(".mega-menu");
  megamenu.forEach(box => {
    box.addEventListener('click', function handleClick(event) {
      megamenu.forEach(boxx => {
        boxx.querySelector('span').setAttribute('style', 'border-bottom: 3px solid white;');  
      });    
      box.querySelector('span').setAttribute('style', 'border-bottom: 3px solid black;');
    });    
  });
  
  if (screen.width < 910) {
  
    let items = document.querySelectorAll('.footer-menu-action');
  
    items.forEach(function(elem) {
      elem.addEventListener("click", function() {
        let plus = this.querySelector('.footer-plus-icon');
        let minus = this.querySelector('.footer-minus-icon');
        if (plus.style.display === "none") {
          plus.style.display = "block";
          minus.style.display = "none";
          this.nextSibling.nextSibling.style.display = "none";
        } else {
          plus.style.display = "none";
          minus.style.display = "block";
          this.nextSibling.nextSibling.style.display = "block";
        }
        
      });
    });
    
  }
  
})();